// extracted by mini-css-extract-plugin
export default {"header":"Table_header__LA1aH"};